var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "page-wecom-seminar-divide" })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }